export const SET_WAREHOUSES = 'SET_WAREHOUSES';
export const FAILED_GET_WAREHOUSES = 'FAILED_GET_WAREHOUSES';
export const SET_WAREHOUSE = 'SET_WAREHOUSE';
export const FAILED_UPDATE_WAREHOUSES = 'FAILED_UPDATE_WAREHOUSES';
export const UPDATE_WAREHOUSE = 'UPDATE_WAREHOUSES';
export const FAILED_GET_WAREHOUSE = 'FAILED_GET_WAREHOUSE';


// WEBPACK FOOTER //
// src/state/constants/warehouseConstants.js